exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input[type='text'][data-v-975ec53e] {\n  width: 100%;\n  padding: 12px 20px;\n  margin: 4px 0;\n  box-sizing: border-box;\n  border: none;\n  /*background-color: grey;\n      color: white;*/\n}\n.name-title[data-v-975ec53e] {\n  font-size: 14px;\n  font-weight: 500;\n  color: #06263e;\n}\n", ""]);

// exports
